import React from 'react'
import {
    Flex,
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
    Box,
    useStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import RecipeFilterModalTile from './recipe-filter-modal-tile'
import PropTypes from 'prop-types'
import {ChevronDown} from '../../icons'

const RecipeFilterModalCategories = ({
    filter,
    isOpen,
    tempSelectedFilters,
    setTempSelectedFilters,
}) => {
    const accordionStyles = useStyleConfig('Accordion')

    return (
        <Flex w="100%">
            <Accordion w="100%" allowToggle>
                <AccordionItem {...accordionStyles?.item}>
                    <Flex w="100%" justifyContent="space-between">
                        <AccordionButton {...accordionStyles?.button}>
                            <Box
                                flex="1"
                                textAlign="left"
                                textStyle="body-large"
                                fontWeight="normal"
                            >
                                {filter?.name}
                            </Box>
                            <ChevronDown />
                        </AccordionButton>
                    </Flex>

                    <AccordionPanel {...accordionStyles?.panel} gap="medium.base">
                        {filter &&
                            filter?.options?.map((option, idx) => {
                                return (
                                    <RecipeFilterModalTile
                                        option={option}
                                        fieldUID={filter?.fieldUID}
                                        key={idx}
                                        isOpen={isOpen}
                                        isChecked={tempSelectedFilters[filter?.fieldUID]?.some(
                                            (item) =>
                                                item?.contentstackValue ===
                                                option?.contentstackValue,
                                        )}
                                        setTempSelectedFilters={setTempSelectedFilters}
                                    />
                                )
                            })}
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </Flex>
    )
}
RecipeFilterModalCategories.propTypes = {
    filter: PropTypes.object,
    tempSelectedFilters: PropTypes.object,
    setTempSelectedFilters: PropTypes.func,
    isOpen: PropTypes.bool,
}
export default RecipeFilterModalCategories
